export default __webpack_public_path__ + "static/media/about_us_5.c2b46890.jpeg";